import {Component, Input, OnInit} from "@angular/core";
import {PedidosService} from "../../services/pedidos.service";
import {Router} from "@angular/router";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-copiar-pedido',
  templateUrl: './copiar-pedido.component.html',
  styleUrls: ['./copiar-pedido.component.scss']
})
export class CopiarPedidoComponent implements OnInit {
  @Input() pedido: any;
  @Input() exibirTexto = false;
  constructor( protected pedidosService: PedidosService,  private router: Router) {
  }
  ngOnInit( ) {

  }

  duplicarPedido() {
    this.pedidosService.validePedirNovamente(this.pedido.guid).then((resposta: any) => {
      this.router.navigateByUrl(`/admin/pedidos/copiar/${this.pedido.guid}`);
    }).catch((erro) => {
      console.error(erro)
      alert(erro)
    });
  }
}
